var bulletListSelector = '.ak-ul';
var bulletList = {
    group: 'block',
    content: 'listItem+',
    parseDOM: [{ tag: 'ul' }],
    toDOM: function () {
        var attrs = {
            class: bulletListSelector.substr(1),
        };
        return ['ul', attrs, 0];
    },
};

export { bulletList, bulletListSelector };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/bullet-list.js